<template>
  <ProductCard v-if="product" :product="product" :media="imageUrl" />
</template>

<script>
import ProductCard from "@/components/ProductCard.vue";
import productQuery from "@/graphql/queries/Product.gql";

export default {
  name: "AddFromPhoto",
  components: {
    ProductCard,
  },
  props: {
    productHandle: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      product: null,
    };
  },
  apollo: {
    product: {
      query: productQuery,
      variables() {
        return {
          product: this.productHandle,
          selectedOptions: [],
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.media-wrapper) {
  aspect-ratio: auto;
}
:deep(.info__left) {
  padding: 0 5px;
}
</style>
